<template>
  <div></div>
</template>

<script>
export default {
  created(){
    this.loginRegister()
  },
  methods: {
    loginRegister() {
      let id = this.$route.query.openId
      let userState = this.$route.query.userState
      if(id!=null){
        sessionStorage.setItem("openId",id)
      }else{

          let sessionId=sessionStorage.getItem("openId");
          if(sessionId!=null){
             id=sessionId;
          }

      }
      if(userState==0){
        this.$router.push({path: '/login'})
      }else {
        let _this = this;
        let url = "/common/"+id+"/selectTokenByWxID";
        return new Promise((resolve, reject) => {
          _this.$axios.get(url)
          .then(data => {
                if(data.code==200){
                  localStorage.setItem("accessToken", data.data.token);
                  sessionStorage.setItem("accessToken", data.data.token)
                   sessionStorage.setItem("id", data.data.id)
                 // localStorage.setItem("login_data", JSON.stringify(data.data));
                   sessionStorage.setItem("memPicture",data.data.memPicture);
                  this.$router.push({path: '/home'})
              }else{
                this.$router.push({path: '/login'})
              }
            })
        });
        }
    }
  },
}
</script>

<style scoped>

</style>